app.controller("StatisticsIndexController", ["$scope", "$stateParams", "$uibModal", "$state", "PollService", "usSpinnerService",
    function ($scope, $stateParams, $uibModal, $state, PollService, usSpinnerService) {
        $scope.totalItems = 0;
        $scope.itemsPerPage = 20;
        $scope.title = "";
        $scope.wasSent = 0;
        $scope.read = 0;
        $scope.unread = 0;
        $scope.answered = 0;
        $scope.answers = [];
        $scope.textAnswers = [];
        $scope.fromAll = 0;

        $scope.goToPage = function (page) {
            $state.go(".", {page: page});
        };

        $scope.changePage = function () {
            $scope.goToPage($scope.currentPage);
        };

        $scope.getStats = function (pollId) {
            PollService.getStats({
                pollId: pollId
            }).then(function (data) {
                var stats = data.stats;
                $scope.poll = data.poll;
                $scope.wasSent = _(stats).sumBy('count');
                $scope.answered = _(stats).filter(function (stat) {
                    return stat._id.state === 'answered'
                }).sumBy('count');

                $scope.unread = _(stats).find(function (stat) {
                    return stat._id.state === 'unread'
                });
                $scope.unread = $scope.unread ? $scope.unread.count : 0;
                $scope.read = _(stats).find(function (stat) {
                    return stat._id.state === 'read'
                });
                $scope.read = $scope.read ? $scope.read.count : 0;

                _(stats).filter(function (stat) {
                    return stat._id.state === 'answered'
                }).each(function (stat) {
                    $scope.answers.push({
                        answer: $scope.poll.answers[stat._id.answer],
                        count: stat.count,
                        fromRead: (stat.count * 100 / $scope.answered).toFixed(2),
                        fromAll: (stat.count * 100 / $scope.wasSent).toFixed(2)
                    });
                    $scope.textAnswers.push(stat._id.answer)
                });

                if ($scope.poll.anonymous === 'text' || !$scope.poll.anonymous) {
                    loadPage($stateParams.page, function () {
                        $scope.currentPage = $stateParams.page;
                    })
                }
            });
        };

        $scope.getStats($stateParams.pollId);

        function loadPage(page, cb) {
            cb = cb || function () {
                };
            usSpinnerService.spin("root");
            PollService.getAnswers({
                pollId: $stateParams.pollId,
                limit: $scope.itemsPerPage,
                page: page
            }).then(function (data) {
                $scope.answersList = data.docs;
                $scope.totalItems = data.total;
                usSpinnerService.stop("root");
                cb();
            })
        }
    }
]);